export const SPOTTED_ZEBRA_SCORE_DATA_TEST_ID = 'spotted-zebra-score-section';
export const SPOTTED_ZEBRA_SCORE_LABEL = 'Assessment score';
export const SPOTTED_ZEBRA_SCORE_HELP_TEXT =
  "Shows the Assessment score in the company app's assessment table. ATS integrations always receive the score, whatever this setting.";
